
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'right',
    },
    popupType: {
      type: String,
    },
  },
  emits: ['input', 'togglePCPopupVisible'],
  setup(props, { emit }) {
    const methods = {
      togglePCPopupVisible(isShow: boolean) {
        emit('togglePCPopupVisible', isShow, 'citySideBar')
      },
    }
    return {
      ...methods,
    }
  },
})
